import { render } from "./event5.vue?vue&type=template&id=104ee9a3"
import script from "./event5.vue?vue&type=script&lang=js"
export * from "./event5.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__